module.exports = __webpack_public_path__ + "img/MapThumb_BlackForest.25b1cefc.webp";